module.exports = __webpack_public_path__ + "img/list_hk1_3_zh.8b4282ce.png";